/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { PiClockCountdownBold } from "react-icons/pi";

export function StockExpiryCountdown({expireAt,userinfo}) {

  const [remaining, setRemaining] = useState('');
  const [diffTime, setDiffTime] = useState(0);
  // Helper to pad with leading zeros
  const pad = (num) => String(num).padStart(2, '0');


const isWarning = diffTime > 0 && diffTime < 12 * 60 * 60 * 1000;

useEffect(() => {
  if (!expireAt || !userinfo?.timezone) {
    setRemaining('Loading..');
    return;
  }

  const targetTime = moment(expireAt).tz(userinfo.timezone);

  const interval = setInterval(() => {
    const now = moment.tz(userinfo.timezone);
    const diff = targetTime.diff(now);
    setDiffTime(diff);

    if (diff <= 0) {
      setRemaining('expired');
      clearInterval(interval);
    } else {
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      setRemaining(`${pad(hours)}:${pad(minutes)}:${pad(seconds)}`);
    }
  }, 1000);

  return () => clearInterval(interval);
}, [expireAt, userinfo]);

  return (
    <>
      <div className={`card card-custom ${userinfo.stockStatus === 1 ? 'viewprofile' : isWarning ? 'stockwarn' : remaining === 'expired' ? 'confhistory' : 'salehistory'} card-stretch gutter-b`} style={{ height: "120px" }} >
          <div className="card-body d-flex flex-column justify-content-center">
         { userinfo.stockStatus === 1 ? 
            <div className="text-white font-weight-bolder text-center font-size-h2 mt-3">Freeze</div>
             :
              <>
                {remaining === 'expired'
                  ? 
                    <div className="text-white font-weight-bolder text-center font-size-h2 mt-3">Stock Expired</div>
                  : 
                    <>
                        <span className="text-light text-center font-weight-bold font-size-lg">Stock Expired in(Hours)</span>
                        <div className="text-white font-weight-bolder text-center font-size-h2 mt-3">{remaining}</div>
                    </>
                  }
              </>}
            <div className="bgIcon">
              <PiClockCountdownBold />
            </div>
          </div>
      </div>
    </>
  );
}
